import PopupDelete from "../../../component/PopupDelete/PopupDelete";
import {genderList, quantityList} from "./lists";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import React from "react";

export default function PopupDeleteAnimal({
                                              baseUrl,
                                              setLoadData,
                                              item
                                          }) {



    const title = 'Confirmar Exclusão de Animal'

    const buttonText = <>
        <DeleteForeverIcon fontSize="medium"/>
        &nbsp; Cancelar Boleto
    </>


    return (
        <PopupDelete
            baseUrl={baseUrl} setLoadData={setLoadData}
            title={title} id={item.id}
            buttonClass={'dropdown-item text-danger'}
            buttonText={buttonText}
        >

            <div className="mt-3 mb-3">
                <b>Número do lote: </b>
                <>{item.numeroLote}</>
                <br/>

                <b>Evento: </b>
                <>{item.evento}</>
                <br/>

                <b>Nome: </b>
                <>{item.nomeAnimal}</>
                <br/>

                <b>Gênero: </b>
                <>{item.generoAnimal}</>
                <br/>

                <b>Quantidade: </b>
                <>{item.quantidade}</>
                <br/>

            </div>

            <p className="mb-3">Você deseja realmente excluir este registro?</p>

        </PopupDelete>
    )
}